export default __webpack_public_path__ + "static/media/assessment-map-new.f1673af2.svg";